"use strict";

import {DropdownMenu, Item, Separator} from "./DropdownMenu";
export {DropdownMenu as DropdownMenu};
export {Item as Item};
export {Separator as Separator};


// WEBPACK FOOTER //
// ./~/vwa/components/DropdownMenu/index.js